<template>
  <sui-accordion exclusive styled>
    <sui-accordion-title>
      <sui-icon name="dropdown" />
      {{ $t('cat1aLabel') }}
    </sui-accordion-title>
    <sui-accordion-content>
      <p v-html="$t('cat1aContent')" />
    </sui-accordion-content>
    <sui-accordion-title>
      <sui-icon name="dropdown" />
      {{ $t('cat1bLabel') }}
    </sui-accordion-title>
    <sui-accordion-content>
      <p v-html="$t('cat1bContent')" />
    </sui-accordion-content>
    <sui-accordion-title>
      <sui-icon name="dropdown" />
      {{ $t('cat1cLabel') }}
    </sui-accordion-title>
    <sui-accordion-content>
      <p v-html="$t('cat1cContent')" />
    </sui-accordion-content>
  </sui-accordion>
</template>

<script>
  export default {
    data() {
      return {

      }
    }
  }</script>

<style lang="scss" scoped>
</style>
